<div class="vb-spinner-box vb-spinner-box--page">
    <vb-spinner size="xl" label="Loading"></vb-spinner>
</div>
